import React from 'react'
import { makeStyles } from '@mui/styles'
import clsx from 'clsx'
import ThemeInterface from '@/theme-interface'
import SimpleBar, { Props as SimpleBarComponentProps } from 'simplebar-react'

interface Props extends Omit<SimpleBarComponentProps, 'onAbort' | 'children'> {
  className?: string;
  children: React.ReactNode;
  maxHeight?: number | string;
}

const useStyles = makeStyles<ThemeInterface, Props>((theme) => ({
  scrollbar: {
    '&::before': {
      backgroundColor: theme.lightGrey,
    },
  },
}))

function CustomScrollbar(props: Props) {
  const classes = useStyles(props)
  const { className, children, maxHeight = 300, autoHide = true, ...otherProps } = props

  return (
    <SimpleBar
      {...otherProps}
      className={clsx(className)}
      classNames={{
        scrollbar: clsx('simplebar-scrollbar', classes.scrollbar),
      }}
      autoHide={autoHide}
      style={{ maxHeight }}
    >
      {children}
    </SimpleBar>
  )
}

export default CustomScrollbar
